import React from 'react';

const SITE_URL = 'https://coachginge.com';
const TALES_URL = 'https://www.youtube.com/playlist?list=PLU9nyIBhayTo';

const post = {
  slug: 'coach-ginge-toy-box-tales',
  title: 'Coach Ginge starts telling stories',
  date: '2026-10-25',
  cover: '/blog/coach-ginge-toy-box-tales/cover.jpg',
  coverAlt:
    'Coach Ginge, Sugar and Fluffy popping up out of a candy-striped felt toy box, with the words Toy Box Tales',
  excerpt:
    'Toy Box Tales, three short animated stories about how Coach Ginge became a coach, is out now. Plus all seven Halloween brain breaks, a new look for Ginge, and what is coming before Christmas.',
  content: (
    <>
      <p>
        When Coach Ginge{' '}
        <a href="/blog/coach-ginge-for-kids">went back to school</a> at the
        end of September, every video was a brain break: Ginge calls the
        moves, the children copy them, and a few minutes later everyone sits
        back down. Since then he has picked up a witch&apos;s hat and a ghost
        kitten called Boo, and on Sunday he did something we hadn&apos;t
        planned at the start, which was to tell some stories.
      </p>

      <h2>Toy Box Tales</h2>
      <p>
        Children only ever met Coach Ginge halfway through a workout, so we
        wanted to give them a way to get to know him and his friends. Toy Box
        Tales is three short animated stories, about four minutes in all, with
        Ginge reading them in his own voice and Sugar and Fluffy joining in.
      </p>
      <ul>
        <li>
          <strong>How Ginge Got His Whistle.</strong> Before he was a coach he
          was just Ginge, the best napper in the city. A laser dot jumps out of
          his toy box, the kittens copy everything he does without listening
          to a word, and at the bottom of the toy box he finds the one thing
          cats do listen to.
        </li>
        <li>
          <strong>How Coach Ginge Met Sugar and Fluffy.</strong> A coach needs
          a team. Three pounces later (a box, a tree that turns out to be
          Fluffy, and his own nose) there are three cats living in one house.
        </li>
        <li>
          <strong>Coaching Cats Is Easy!</strong> Ginge sets out to show us
          how it&apos;s done. He blows the whistle and calls a move, and every
          cat does the opposite, until Dozer the bulldog wakes up and the
          whole class finds the one word they all obey.
        </li>
      </ul>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/RlPaUmoej1o"
          title="Toy Box Tales: How Coach Ginge Met Sugar and Fluffy, story time for kids"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>From picture book to cartoon</h2>
      <p>
        The stories started out as picture books. Each one was written to run
        under a minute and drawn as a set of felt pictures from the same
        character cards we use for the thumbnails, and the first version was
        just those pictures, gently panned, with Ginge reading over them. It
        worked, but it was a bit still, so we went back and turned every
        picture into a short animated shot. That took a lot of fixing: the
        kittens had to stay the same kittens from one shot to the next, the
        toy box kept changing, one kitten decided to walk on its back legs and
        a sleeping kitten briefly grew a second tail. Like the brain breaks,
        Toy Box Tales is made with the help of AI tools, and every shot is
        checked by hand before it goes in.
      </p>

      <figure className="post-figure">
        <img
          src="/blog/coach-ginge-toy-box-tales/story-time.jpg"
          alt="Coach Ginge reading a storybook to Sugar and Fluffy beside the toy box, a round window over felt rooftops behind them"
        />
        <figcaption>Story time at Coach Ginge&apos;s house.</figcaption>
      </figure>

      <h2>Halloween, and a new look for Ginge</h2>
      <p>
        All seven Halloween brain breaks are out now: the five from the{' '}
        <a href="/blog/coach-ginge-halloween">last post</a>, plus Boo&apos;s
        Coming!, a freeze game where you dance while Boo&apos;s back is turned
        and freeze when he turns round, and Going on a Ghost Hunt!, where the
        cats march, tiptoe and squelch through four Halloween places to find
        him. Ginge has had a makeover along the way too. We redrew his face to
        look more like Grandad, softer and rounder, and the newer videos all
        have the new him.
      </p>

      <h2>Coming up</h2>
      <p>
        Two more this week. Choo-Choo Chase! on Tuesday sends the laser dot
        off on a train through Toy Town, the mountains and over the Rainbow
        Bridge, with Zippy the cheetah cub joining the chase, and on Thursday
        Coach Ginge takes on Zippy in a Halloween race where children pick a
        runner and run on the spot with them. November brings Cosy Cat Stroll,
        a calm after-dinner wind-down, a food edition of Would You Rather? and
        a Thanksgiving Turkey Trot, and the Christmas brain breaks start on 23
        November. The next Toy Box Tales, for Christmas, are being written
        now.
      </p>

      <div className="post-callout">
        <h3>Know a child who&apos;d like a story?</h3>
        <p>
          Toy Box Tales is free on YouTube, in its own{' '}
          <a href={TALES_URL}>Toy Box Tales playlist</a>, and on{' '}
          <a href={SITE_URL}>coachginge.com</a> with all the brain breaks.
          It works well after a run-around, or on a rainy afternoon at home.
        </p>
      </div>

      <p className="post-signoff">
        For Grandad, who never once listened to a whistle.
      </p>
    </>
  ),
};

export default post;
